import { lazy } from 'react'
import { Role } from '../../utility/types'
// ** Document title
const TemplateTitle = '%s - Analytics Portal'

// ** Default Route
const DefaultRoute = '/landing/home'
const MainRoute = '/'
const ErrorPageRoute = '/error'

const PreDefinedRoutes = (centrali3_0 = false) => [
  {
    path: '/app-store',
    component: lazy(() => import('../../views/_pages/Dashboard')),
    meta: {
      authRoute: true,
      isNewUiAccessible: false
    }
  },
  {
    path: '/categories/view/:id',
    component: lazy(() => import('../../views/_pages/SingleCategory')),
    meta: {
      authRoute: true,
      isNewUiAccessible: false
    }
  },
  {
    path: '/applications',
    component: lazy(() => import('../../views/_pages/Applications/AllApplications')),
    exact: true,
    meta: {
      authRoute: true,
      isAccessibleBy: [Role.Admin, Role.Contributor]
    }
  },
  {
    path: '/applications/:name/contributors',
    component: lazy(() => import('../../views/_pages/Applications/Contributors')),
    layout: 'VerticalLayout',

    meta: {
      authRoute: true,
      isAccessibleBy: [Role.Admin, Role.Contributor]
    }
  },
  {
    path: '/new-app',
    component: lazy(() => import('../../views/_pages/Applications/Applications')),
    meta: {
      authRoute: true,
      isAccessibleBy: [Role.Admin, Role.Contributor]
    }
  },
  {
    path: '/edit-app/:id',
    component: lazy(() => import('../../views/_pages/Applications/Applications')),
    meta: {
      authRoute: true,
      isAccessibleBy: [Role.Admin, Role.Contributor]
    }
  },

  {
    path: '/application-store',
    component: lazy(() => import('../../views/_pages/AppStore')),
    meta: {
      authRoute: true,
      isNewUiAccessible: true
    }
  },
  {
    path: '/data-marketplace',
    component: lazy(() => import('../../views/_pages/Data-marketplace/DataMarketplace')),
    meta: {
      authRoute: true
    }
  },
  {
    path: '/ai-marketplace',
    component: lazy(() => import('../../views/_pages/AI-marketplace/AIMarketplace')),
    meta: {
      authRoute: true,
      isNewUiAccessible: true
    }
  },
  {
    path: '/ai-marketplace/agents/:agentId',
    component: lazy(() => import('../../views/_pages/AI-marketplace/AgentDetails')),
    meta: {
      authRoute: true,
      isNewUiAccessible: true
    }
  },
  {
    path: '/ai-marketplace/skills/:skillId',
    component: lazy(() => import('../../views/_pages/AI-marketplace/SkillDetails')),
    meta: {
      authRoute: true,
      isNewUiAccessible: true
    }
  },
  {
    path: '/teams',
    component: lazy(() => import('../../views/_pages/Teams/TeamsPage')),
    meta: {
      authRoute: true,
      isNewUiAccessible: true
    }
  },
  {
    path: '/teams/:teamId',
    component: lazy(() => import('../../views/_pages/Teams/TeamDetailsWrapper')),
    meta: {
      authRoute: true,
      isNewUiAccessible: true
    }
  },
  {
    path: '/teams/:teamId/add-agent',
    component: lazy(() => import('../../views/_pages/Chatbot/agent/TeamsManageAgents')),
    meta: {
      authRoute: true,
      isNewUiAccessible: true
    }
  },
  {
    path: '/teams/:teamId/edit-agent/:agentId',
    component: lazy(() => import('../../views/_pages/Chatbot/agent/TeamsManageAgents')),
    meta: {
      authRoute: true,
      isNewUiAccessible: true
    }
  },
  {
    path: '/teams/:teamId/databoxes/:id',
    component: lazy(() => import('../../views/_pages/Teams/DataboxDetailPage')),
    meta: {
      authRoute: true,
      isNewUiAccessible: true
    }
  },
  {
    path: '/databoxes/:id',
    component: lazy(() => import('../../views/_pages/Teams/DataboxDetailPage')),
    meta: {
      authRoute: true,
      isNewUiAccessible: true
    }
  },
  {
    path: '/data-marketplace/:id',
    component: lazy(() => import('../../views/_pages/Data-marketplace/Details')),
    meta: {
      authRoute: true
    }
  },
  {
    path: '/data-marketplace/:id/:tab',
    component: lazy(() => import('../../views/_pages/Data-marketplace/Details')),
    meta: {
      authRoute: true
    }
  },
  {
    path: '/chat',
    component: lazy(() => import('../../views/_pages/Chatbot/Chatbot')),
    ...(!centrali3_0 && { layout: 'BlankLayout' }),
    meta: {
      authRoute: true
    }
  },
  {
    path: '/chat/project/:projectId',
    component: lazy(() => import('../../views/_pages/Chatbot/Chatbot')),
    ...(!centrali3_0 && { layout: 'BlankLayout' }),
    meta: {
      authRoute: true,
      isNewUiAccessible: true
    }
  },
  {
    path: '/chat/project/:projectId/:chatId',
    component: lazy(() => import('../../views/_pages/Chatbot/Chatbot')),
    ...(!centrali3_0 && { layout: 'BlankLayout' }),
    meta: {
      authRoute: true,
      isNewUiAccessible: true
    }
  },
  {
    path: '/chat/:chatId',
    component: lazy(() => import('../../views/_pages/Chatbot/Chatbot')),
    ...(!centrali3_0 && { layout: 'BlankLayout' }),
    meta: {
      authRoute: true
    }
  },
  {
    path: '/manage-agents',
    component: lazy(() => import('../../views/_pages/Chatbot/agent/ManageAgents')),
    meta: {
      authRoute: true,
      isNewUiAccessible: true
    }
  },
  {
    path: '/agents/add-agent',
    component: lazy(() => import('../../views/_pages/Chatbot/agent/ManageAgents')),
    meta: {
      authRoute: true,
      isNewUiAccessible: true
    }
  },
  {
    path: '/agents/edit-agent/:agentId',
    component: lazy(() => import('../../views/_pages/Chatbot/agent/ManageAgents')),
    meta: {
      authRoute: true,
      isNewUiAccessible: true
    }
  },
  {
    path: '/agents/:agentId/memories',
    component: lazy(() => import('../../views/_pages/Chatbot/agent/AgentMemories')),
    meta: {
      authRoute: true,
      isNewUiAccessible: true
    }
  },
  {
    path: '/categories',
    component: lazy(() => import('../../views/_pages/Categories')),
    meta: {
      authRoute: true,
      isNewUiAccessible: false
    }
  },
  {
    path: '/profile',
    component: lazy(() => import('../../views/_pages/Profile')),
    meta: {
      authRoute: true
    }
  },
  {
    path: '/search',
    component: lazy(() => import('../../views/_pages/Search')),
    meta: {
      authRoute: true,
      isNewUiAccessible: false
    }
  },
  {
    path: '/all-applications',
    component: lazy(() => import('../../views/_pages/Search')),
    meta: {
      authRoute: true,
      isNewUiAccessible: false
    }
  },
  {
    path: '/my-space',
    component: lazy(() => import('../../views/_pages/NewMySpace')),
    meta: {
      authRoute: true,
      isNewUiAccessible: true
    }
  },
  {
    path: '/myspace',
    component: lazy(() => import('../../views/_pages/MySpace')),
    meta: {
      authRoute: true,
      isNewUiAccessible: false
    }
  },
  {
    path: '/download',
    component: lazy(() => import('../../views/_pages/Download')),
    meta: {
      authRoute: true
    }
  },
  {
    path: '/apps/:id',
    component: lazy(() => import('../../views/_pages/AppDetails')),
    meta: {
      authRoute: true
    }
  },
  {
    path: '/preview/:id',
    component: lazy(() => import('../../views/_pages/AppDetailsPreview')),
    meta: {
      authRoute: true
    }
  },
  {
    path: '/notifications',
    component: lazy(() => import('../../views/_pages/Notifications')),
    meta: {
      authRoute: true
    }
  },
  {
    path: '/workspace',
    component: lazy(() => import('../../views/_pages/Work-space/Main')),
    ...(!centrali3_0 && { layout: 'BlankLayout' }),
    meta: {
      authRoute: true
    }
  },
  {
    path: '/apps/work-browser',
    component: lazy(() => import('../../views/_pages/Work-space/Main')),
    layout: 'BlankLayout',
    meta: {
      authRoute: false
    }
  },
  {
    path: '/account-info',
    component: lazy(() => import('../../views/_templates/LoginTemplate')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/landing/:page',
    component: lazy(() => import('../../views/sass-landing/SassLanding')),
    layout: 'BlankLayout',
    meta: {
      authRoute: false
    }
  },
  {
    path: '/fallback',
    component: lazy(() => import('../../views/Fallback')),
    layout: 'BlankLayout',
    meta: {
      authRoute: false
    }
  },
  {
    path: '/error',
    component: lazy(() => import('../../views/Error')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/session-expired',
    component: lazy(() => import('../../views/SessionExpired')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/collections/:id',
    component: lazy(() => import('../../views/_pages/SingleCollection')),
    layout: 'VerticalLayout',
    meta: {
      authRoute: true,
      isNewUiAccessible: false
    }
  },
  {
    path: '/personal-collections/:id',
    component: lazy(() => import('../../views/_pages/SingleCollection')),
    layout: 'VerticalLayout',
    meta: {
      authRoute: true,
      isNewUiAccessible: false
    }
  },
  {
    path: '/collections',
    component: lazy(() => import('../../views/_pages/Collections')),
    layout: 'VerticalLayout',
    meta: {
      authRoute: true,
      isNewUiAccessible: false
    }
  },
  {
    path: '/new-collection',
    component: lazy(() => import('../../views/_pages/NewCollection')),
    meta: {
      authRoute: true,
      isAccessibleBy: [Role.Admin],
      isNewUiAccessible: false
    }
  },
  {
    path: '/edit-collection/:id',
    component: lazy(() => import('../../views/_pages/NewCollection')),
    meta: {
      authRoute: true,
      isAccessibleBy: [Role.Admin],
      isNewUiAccessible: false
    }
  },
  {
    path: '/notification-groups/:id',
    component: lazy(() => import('../../views/_pages/NotificationGroupMembers')),
    layout: 'VerticalLayout',
    meta: {
      authRoute: true,
      isAccessibleBy: [Role.Admin, Role.Contributor]
    }
  },
  {
    path: '/notification-groups',
    component: lazy(() => import('../../views/_pages/NotificationGroups')),
    layout: 'VerticalLayout',
    meta: {
      authRoute: true,
      isAccessibleBy: [Role.Admin, Role.Contributor]
    }
  },
  {
    path: '/schedules',
    component: lazy(() => import('../../views/_pages/ManageSchedules')),
    layout: 'VerticalLayout',
    meta: {
      authRoute: true,
      isAccessibleBy: [Role.Admin, Role.Contributor]
    }
  },
  {
    path: '/data-product-admin',
    component: lazy(() => import('../../views/_pages/DataProductAdmin/DataProductAdmin')),
    layout: 'VerticalLayout',
    meta: {
      authRoute: true,
      isAccessibleBy: [Role.Admin]
    }
  },
  {
    path: '/data-product-admin/:id',
    component: lazy(() => import('../../views/_pages/DataProductAdmin/Details')),
    layout: 'VerticalLayout',
    meta: {
      authRoute: true,
      isAccessibleBy: [Role.Admin]
    }
  },
  {
    path: '/data-product-admin/:id/:tab',
    component: lazy(() => import('../../views/_pages/DataProductAdmin/Details')),
    layout: 'VerticalLayout',
    meta: {
      authRoute: true,
      isAccessibleBy: [Role.Admin]
    }
  },
  {
    path: '/feature-gates',
    component: lazy(() => import('../../views/_pages/FeatureGates/FeatureGatesAdmin')),
    layout: 'VerticalLayout',
    meta: {
      authRoute: true,
      isAccessibleBy: [Role.Admin]
    }
  },
  {
    path: '/banners',
    component: lazy(() => import('../../views/_pages/Banners/BannersAdmin')),
    layout: 'VerticalLayout',
    meta: {
      authRoute: true,
      isAccessibleBy: [Role.Admin]
    }
  },
  {
    path: '/agents-skills',
    component: lazy(() => import('../../views/_pages/AgentsAndSkills/AIMarketplaceAdmin')),
    layout: 'VerticalLayout',
    meta: {
      authRoute: true,
      isAccessibleBy: [Role.Admin]
    }
  },
  {
    path: '/manage-mcp',
    component: lazy(() => import('../../views/_pages/ManageMCP/ManageMCPAdmin')),
    layout: 'VerticalLayout',
    meta: {
      authRoute: true,
      isAccessibleBy: [Role.Admin]
    }
  }
]

export { DefaultRoute, MainRoute, ErrorPageRoute, TemplateTitle, PreDefinedRoutes }
